module.exports = __webpack_public_path__ + "static/media/show-more-ico.45c78b8b.svg";